import $http from '@/libs/axios'

class RolesAPI {
  public static async getPermissions() {
    return (await $http.get('permissions')).data
  }

  public static async getRoles(params: Record<string, any> = {}) {
    return (await $http.get('roles', { params })).data
  }

  public static async getRolesForSubusers(params: Record<string, any> = {}) {
    return (await $http.get('roles-for-subusers')).data
  }

  public static async deleteRole(roleId: number) {
    return (await $http.delete(`roles/${roleId}`)).data
  }

  public static async update(id: number, data: any) {
    return (await $http.put(`roles/${id}`, data)).data
  }

  public static async add(data: any) {
    return (await $http.post('roles', data)).data
  }

  public static async assignUsers(data: any) {
    return (await $http.post('role/assign-users', data)).data
  }
}

export default RolesAPI
